var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUserBotChats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-2{fill:#6c7ef2}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2315",
    "data-name": "Group 2315",
    transform: "translate(-204 -159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_4182",
    "data-name": "Rectangle 4182",
    style: {
      fill: "#fff",
      stroke: "#707070",
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H98V98H0z",
    style: {
      stroke: "none"
    },
    transform: "translate(204 159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H97.5V97.5H0.5z",
    style: {
      fill: "none"
    },
    transform: "translate(204 159)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__noun_Wind_1729453",
    transform: "translate(211.331 164.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1593",
    d: "M78.239 30.2a11.5 11.5 0 0 0-8.245-3.4v6.8a4.623 4.623 0 0 1 3.4 1.445 4.845 4.845 0 0 1-3.4 8.245H11.6v6.8h58.394a11.644 11.644 0 0 0 8.245-3.4 11.5 11.5 0 0 0 3.4-8.245 11.644 11.644 0 0 0-3.4-8.245z",
    className: "prefix__cls-2",
    "data-name": "Path 1593",
    transform: "translate(-1.5 -2.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1594",
    d: "M63.139 24.445a11.645 11.645 0 0 0-23.29 0h6.8a4.845 4.845 0 1 1 4.845 4.845H1.6v6.8h49.894a11.608 11.608 0 0 0 11.645-11.645z",
    className: "prefix__cls-2",
    "data-name": "Path 1594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1595",
    d: "M45.995 60.2H21.6V67h24.395a4.809 4.809 0 1 1-4.845 4.845h-6.8a11.645 11.645 0 1 0 23.29 0A11.608 11.608 0 0 0 45.995 60.2z",
    className: "prefix__cls-2",
    "data-name": "Path 1595",
    transform: "translate(-3 -7.111)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUserBotChats);
export default __webpack_public_path__ + "static/media/no_user_bot_chats.76c875ca35f4a09f2bc8dc01c6580e31.svg";
export { ForwardRef as ReactComponent };